<template>
	<div class="group-item" :class="active ? 'active' : ''">
		<div class="group-avatar">
			<head-image :size="42" :name="group.showGroupName" :url="group.headImageThumb"> </head-image>
		</div>
		<div class="group-name">
			<div>{{ group.showGroupName }}</div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "groupItem",
	components: {
		HeadImage
	},
	data() {
		return {}
	},
	props: {
		group: {
			type: Object
		},
		active: {
			type: Boolean
		}
	}
}
</script>

<style lang="scss" scoped>
.group-item {
	height: 50px;
	display: flex;
	position: relative;
	border: 1px solid transparent;
	border-radius: 8px;
	margin: 0 3px;
	padding: 5px 8px;
	cursor: pointer;
	color: var(--im-tech-text);
	transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		background: rgba(18, 74, 126, 0.24);
		border-color: rgba(43, 223, 255, 0.24);
	}

	&.active {
		background:
			linear-gradient(135deg, rgba(8, 125, 255, 0.28), rgba(43, 223, 255, 0.1)),
			rgba(6, 28, 58, 0.52);
		border-color: rgba(43, 223, 255, 0.72);
		box-shadow: 0 0 18px rgba(43, 223, 255, 0.24), inset 0 0 24px rgba(8, 125, 255, 0.14);
	}

	.group-name {
		padding-left: 10px;
		height: 100%;
		text-align: left;
		line-height: 50px;
		white-space: nowrap;
		overflow: hidden;
		font-size: var(--im-font-size);
		font-weight: 600;
		color: var(--im-tech-text);
	}
}
</style>
